<template lang="pug">
  component(v-bind:is="component")
</template>
<script>
import { mapState } from 'vuex'
import InfoPaymentV1 from '@/components/organisms/InfoPayment_v1.vue'
import InfoPaymentV2 from '@/components/organisms/InfoPayment_v2.vue'

export default {
  name: 'InfoPayment',
  components: {
    InfoPaymentV1,
    InfoPaymentV2
  },
  computed: {
    ...mapState(['product']),
    component () {
      /*
        Check if it is cellphone or devices, if it is, then use
        InfoPaymentV2 with some layout changes. Later we will
        unify for all to use v2.
      */
      if (/celular|dispositivos|bolsa-protegida/.test(this.product.alias)) {
        return InfoPaymentV2
      }
      /*
        Otherwise, use InfoPaymentV1, the default one.
      */
      return InfoPaymentV1
    }
  }
}
</script>
